import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import './PasswordChange.css';
import ErrorMessage from '../ErrorMessage';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import FormControl from '@material-ui/core/FormControl';
import InputAdornment from '@material-ui/core/InputAdornment';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import IconButton from '@material-ui/core/IconButton';
import Page from '../Page/Page';
import api_url from "../../consts";

@inject('authStore')
@observer
class ChangePassword extends Component {
  state = {
    showPasswordOld:false,
    showPassword:false,
    showPasswordC:false
  };

  handleOldPasswordChange = (e) => {
    this.props.authStore.setOldPassword(e.target.value);
  };

  handleNewPasswordChange = (e) => {
    this.props.authStore.setNewPassword(e.target.value);
  };

  handleNewPasswordCChange = (e) => {
    this.props.authStore.setNewPasswordC(e.target.value);
  };

  handleChange = (e) => {
    e.preventDefault();
    this.props.authStore.changePassword();
  }

  handleClickShowPasswordOld = () => {

    this.setState({
      ...this.state,
      showPasswordOld: !this.state.showPasswordOld
    })
  };

  handleClickShowPassword = () => {
    this.setState({
      ...this.state,
      showPassword: !this.state.showPassword
    })
  };
  handleClickShowPasswordC = () => {
    this.setState({
      ...this.state,
      showPasswordC: !this.state.showPasswordC
    })
  };

  handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  render() {
    const { authStore } = this.props;
    let passwordReset;
    let passwordInfo;
    if (api_url.PWRESET !== null) {
      passwordInfo = "Salasanan uusiminen hoituu nyt sähköpostitunnistautumisella uuden palvelumme kautta.";
      passwordReset = (
        <a href={api_url.PWRESET} target="_blank" rel="noopener noreferrer">Siirry palveluun</a>
      );
    } else {
      passwordInfo = "Salasanan vaihdon jälkeen kirjaudutaan automaattisesti ulos.";
      passwordReset =
      <form
        onSubmit={this.handleChange}
        className="change-password-form"
      >
        <FormControl margin="normal">
          <InputLabel htmlFor="standard-adornment-oldpassword">Vanha salasana</InputLabel>
          <Input
            id="standard-adornment-oldpassword"
            type={this.state.showPasswordOld ? 'text' : 'password'}
            value={authStore.oldpassword}
            onChange={this.handleOldPasswordChange}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={this.handleClickShowPasswordOld}
                  onMouseDown={this.handleMouseDownPassword}
                >
                  {this.state.showPasswordOld ? <Visibility/> : <VisibilityOff/>}
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
        <FormControl margin="normal">
          <InputLabel htmlFor="standard-adornment-newpassword">Uusi salasana</InputLabel>
          <Input
            id="standard-adornment-newpassword"
            type={this.state.showPassword ? 'text' : 'password'}
            value={authStore.newpassword}
            onChange={this.handleNewPasswordChange}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={this.handleClickShowPassword}
                  onMouseDown={this.handleMouseDownPassword}
                >
                  {this.state.showPassword ? <Visibility/> : <VisibilityOff/>}
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
        <FormControl margin="normal">
          <InputLabel htmlFor="standard-adornment-passwordc">Uusi salasana</InputLabel>
          <Input
            id="standard-adornment-passwordc"
            type={this.state.showPasswordC ? 'text' : 'password'}
            value={authStore.newpasswordc}
            onChange={this.handleNewPasswordCChange}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={this.handleClickShowPasswordC}
                  onMouseDown={this.handleMouseDownPassword}
                >
                  {this.state.showPasswordC ? <Visibility/> : <VisibilityOff/>}
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
        <div className="change-password-action">
          {
            authStore.loading ?
              <CircularProgress size={70}/> :

              <Button
                color="primary"
                type="submit"
                className="change-password-submit"
                variant="contained"
                fullWidth
              >
                Vaihda salasana
              </Button>
          }
        </div>
        <br></br>
        <ErrorMessage/>
      </form>
    }

    return (
      <Page title={'Vaihda salasana'}>
        <div className="change-password-wrapper">
          <span className="flex change-password-info">{passwordInfo}</span>
          <div className="change-password-content padding-md">
            {passwordReset}
          </div>
          <span className="flex"></span>
        </div>
      </Page>
    );
  }
}

export default ChangePassword;
